import axios from "../config/axios";
import config from "../config/index";

const trustHub = {
  getProfile: (user_id) =>
    axios.get(`${config.apiBaseURL2}trust-hub/profile/get/${user_id}`),

  createProfile: (profileData) =>
    axios.post(`${config.apiBaseURL2}trust-hub/profile/create`, profileData),

  updateProfile: (profileData) =>
    axios.post(`${config.apiBaseURL2}trust-hub/profile/update`, profileData),

  // Get profile status
  getProfileStatus: (user_id) =>
    axios.get(`${config.apiBaseURL2}trust-hub/profile/status/${user_id}`),

  // Get profile status
  checkTwilioStatus: (user_id) =>
    axios.get(`${config.apiBaseURL2}trust-hub/profile/twilio-status/${user_id}`),

  getUsStates: () => axios.get(`${config.apiBaseURL2}states`)
}

export default trustHub;
